import {
    Text,
    Title,
    List,
    Image,
    TitleOrder,
    Container,
} from "@mantine/core";
import { PlyrComponent, PracticeQuiz } from "../components";
  
export const renderNode = (
    node: any,
    practiceQuizRef?: React.RefObject<HTMLDivElement>,
    setPracticeQuizCompleted?: React.Dispatch<React.SetStateAction<boolean>>
) => {
    const { nodeType, content, value, data } = node;

    switch (nodeType) {
    case "document":
        return content.map((child: any, index: number) => (
        <div key={index}>{renderNode(child, practiceQuizRef, setPracticeQuizCompleted)}</div>
        ));

    case "paragraph":
        return (
        <Text component="p" ta="justify">
            {content.map((child: any, index: number) => {
            if (child.nodeType === "text") {
                if (child.marks?.some((mark: any) => mark.type === "bold")) {
                return (
                    <Text fw={700} component="span" key={index}>
                        {child.value}
                    </Text>
                );
                }
                return (
                <Text component="span" key={index}>
                    {child.value}
                </Text>
                );
            }
            return renderNode(child, practiceQuizRef, setPracticeQuizCompleted);
            })}
        </Text>
        );

    case "text":
        return <Text component="span">{value}</Text>;
    case "hyperlink":
        return (
        <a href={data.uri.replace(/\.$/, "")} target="_blank" rel="noreferrer">
            {content.map((child: any, index: number) => {
            if (child.nodeType === "text") {
                if (child.marks?.some((mark: any) => mark.type === "bold")) {
                    return (
                        <Text fw={700} component="span" key={index}>
                            {child.value}
                        </Text>
                    );
                }
                return (
                    <Text component="span" key={index}>
                        {child.value}
                    </Text>
                );
            }
            return renderNode(child, practiceQuizRef, setPracticeQuizCompleted);
            })}
        </a>
        );

    case "heading-1":
    case "heading-2":
    case "heading-3":
    case "heading-4":
    case "heading-5":
    case "heading-6": {
        const order = parseInt(nodeType.split("-")[1]);
        const headingContent = content.map((child: any, index: number) => {
        if (child.nodeType === "text") {
            if (child.marks?.some((mark: any) => mark.type === "bold")) {
            return (
                <span key={index} style={{ fontWeight: 700 }}>
                {child.value}
                </span>
            );
            }
            return child.value;
        }
        return renderNode(child, practiceQuizRef, setPracticeQuizCompleted);
        });

        return <Title order={order as TitleOrder}>{headingContent}</Title>;
    }

    case "ordered-list":
        return (
        <List withPadding type="ordered">
            {content?.map((child: any, index: number) => renderNode(child, practiceQuizRef, setPracticeQuizCompleted))}
        </List>
        );

    case "unordered-list":
        return (
        <List withPadding>
            {content?.map((child: any, index: number) => renderNode(child, practiceQuizRef, setPracticeQuizCompleted))}
        </List>
        );

    case "list-item": {
        return (
        <List.Item>
            {content.map((child: any, index: number) => {
            if (child.nodeType === "paragraph") {
                return child.content.map((textNode: any, textIndex: number) => {
                    if (textNode.nodeType === "text") {
                        return (
                            <Text
                                fw={textNode.marks?.some((mark: any) => mark.type === "bold") ? 700 : 400}
                                component="span"
                            >
                                {textNode.value}
                            </Text>
                        );
                    }
                    return renderNode(textNode, practiceQuizRef, setPracticeQuizCompleted);
                });
            }
            if (child.nodeType === "unordered-list") {
                return <List withPadding key={index}>{child.content.map((nestedChild: any) => renderNode(nestedChild, practiceQuizRef, setPracticeQuizCompleted))}</List>;
            }

            return renderNode(child, practiceQuizRef, setPracticeQuizCompleted);
            })}
        </List.Item>
        )
    }
        

    case "embedded-asset-block": {
        const mediaUrl = data?.target?.url;

        if (mediaUrl) {
        const isImage = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(mediaUrl);
        const isVideo = /\.(mp4|webm|ogg|mov)$/i.test(mediaUrl);

        if (isImage) {
            return (
            <Image
                src={mediaUrl}
                alt="Embedded image"
                fit="contain"
            />
            );
        }

        if (isVideo) {
            return (
            <Container style={{ maxWidth: "850px" }} mt="md">
                <PlyrComponent videoId={mediaUrl} provider="html5" />
            </Container>
            );
        }
        }

        return null;
    }

    case "embedded-entry-block":
        return (
        <div ref={practiceQuizRef}>
            <PracticeQuiz questions={data.target.questions} setCompleted={setPracticeQuizCompleted!} />
        </div>
        );

    default:
        return null;
    }
};